<script>
import Home from "../pages/Home.vue";
import ChartD3 from "../pages/demo/Chart-d3.vue";
import ChartJS from "../pages/demo/Chart-js.vue";
import Triangular from "../pages/fm/Triangular.vue";
import Trapezoidal from "../pages/fm/Trapezoidal.vue";
import Normal from "../pages/fm/Normal.vue";
import SharpGamma from "../pages/fm/Sharpgamma.vue";
import Cauchy from "../pages/fm/Cauchy.vue";
import Iris from "../pages/datasets/Iris.vue";
import Test from "../pages/demo/Test.vue";
import Inputy from "../pages/demo/Inputy.vue";
import Error404 from "../pages/common/Error404.vue";
import RadvizPage from "../pages/vizualization/RadvizPage.vue"
import RadvizPage2 from "../pages/vizualization/RadvizPage2.vue"

const routes = [
  { path: "/", component: Home },
  { path: "/fm/triangular", component: Triangular },
  { path: "/fm/trapezoidal", component: Trapezoidal },
  { path: "/fm/normal", component: Normal },
  { path: "/fm/sharpgamma", component: SharpGamma },
  { path: "/fm/cauchy", component: Cauchy },
  { path: "/datasets/iris", component: Iris },
  { path: "/demo/test", component: Test },
  { path: "/demo/d3", component: ChartD3 },
  { path: "/demo/chartjs", component: ChartJS },
  { path: "/demo/inputy", component: Inputy },
  { path: "/error400", component: Error404 },
  { path: "/vizualization/radviz", component: RadvizPage },
    { path: "/vizualization/radviz2", component: RadvizPage2 },
  { path: "*", component: Error404 }
];

export default routes;
</script>
